import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Pagination } from '@core/shared/models/pagination';
import { LoadingService } from '@core/shared';
import { OfflineOrderManagementService } from '../service/offlineordermanagement.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@UntilDestroy()
@Component({
    selector: 'app-order-tracking',
    templateUrl: 'offlineorderhistory.component.html',
    styleUrls: [`offlineorderhistory.component.scss`]
})

export class OfflineOrderHistoryComponent implements OnInit {
    tableDisplayData: any = [];
    paginationDetails: Pagination = new Pagination();
    public isWebInMobileView: boolean = false;
    constructor(public loadingService: LoadingService, private offlineOrderManagementService: OfflineOrderManagementService, private modalService: NgbModal) {
        this.isWebInMobileView = localStorage.getItem('token') && JSON.parse(localStorage.getItem('token')).hideHeaderFooter ? true : false;
    }

    onChange(pagination: Pagination) {
        this.paginationDetails = pagination;
        this.getOfflineOrderHistory();
    }

    ngOnInit() {
        this.getOfflineOrderHistory();
    }

    getOfflineOrderHistory() {
        this.loadingService.doLoading(this.offlineOrderManagementService.getOfflineOrderHistoryDetails({ perPage: 10, page: this.paginationDetails?.pageNumber ? this.paginationDetails?.pageNumber : 1 }), this)
            .pipe(untilDestroyed(this)).subscribe(response => {
                this.tableDisplayData = [];
                console.log(response);
                this.paginationDetails.totalNumberOfItems = response?.totalPages ? response?.totalPages * 10 : 0;
                response?.items?.forEach(async (x) => {
                    const averageWidth = x.statusFlow?.length < 2 ? 100 : Math.ceil(100 / (x.statusFlow?.length - 1));
                    let className = '';
                    const targets = x.statusFlow?.map((y, index) => {
                        let width = (index || x.statusFlow?.length > 1) ? averageWidth * index : averageWidth;
                        if (index && x.statusFlow?.length > 3 && index < 3) {
                            width = width - 2;
                        }
                        const obj = { "bgTransparentDot": false, "width": width > 100 ? '100%' : width + '%', "name": y, "className": className };
                        if (y == x.orderStatus) {
                            className = 'progress-dot-gray';
                        }
                        return obj;
                    });
                    x.progress = targets?.find(y => y.name.toLowerCase() == x.orderStatus.toLowerCase())?.width?.replace("%", "");
                    x.targets = targets;
                    this.tableDisplayData.push(x);
                });
            });
    }
}